import React, { useEffect, useState } from "react";
import { useNavigate} from "react-router-dom";
import Layout from "../../components/layout/Layout";
import { Button } from "react-bootstrap";
import { AiOutlineSetting } from "react-icons/ai";
import { GrDocumentTime } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineFileText } from "react-icons/ai";
// import Tour from "reactour";
import { AiOutlineFileProtect } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { getAllTimeSheet } from "../../redux/auth/authSlice";
import { blobURL } from "common/StringUtils";
import { Helmet } from "react-helmet";
import { NewLaunched } from "./NewLaunched";
import { mobileScroll, tourSteps } from "common/FunctionUtils";
import { useViewportWidth } from "components/GetViewPort";
import { LOCALES } from "common/constants";
import UpdatePendingVerification from "./Update-pending-verification/UpdatePendingVerification";
import { resetGetInvoiceData } from "../../../src/redux/auth/authSlice";

// import useUpdateTourStatus from "hooks/useUpdateTourStatus";

const Activities = () => {
  const tender = `${blobURL}/Invoziotender.pdf`;
  const newTenderSwedish = `${blobURL}/StandardOffertInvozioIfyllningsbar.pdf`;
  const contract = `${blobURL}/InvozioContracts.pdf`;
  const newContractSwidish = `${blobURL}/KontraktInvozioIfyllningsbar.pdf`;
  const viewportWidth = useViewportWidth();
  // ----------------------------------Translation------------------------------------

  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const dispatch = useDispatch();

  // ----------------------------------Use-selector------------------------------------
  const { user, isLoading } = useSelector((state) => state?.auth);
  // const { isLoading } = useSelector((state) => state?.auth);

  const [users, setUsers] = useState(() => JSON.parse(localStorage.getItem("user")));

  useEffect(() => {
    const handleUserUpdate = () => {
      const updatedUser = JSON.parse(localStorage.getItem("user"));
      setUsers(updatedUser);
    };

    // Listen for the custom event
    window.addEventListener("userUpdated", handleUserUpdate);

    return () => {
      // Cleanup the event listener
      window.removeEventListener("userUpdated", handleUserUpdate);
    };
  }, []);

  let navigate = useNavigate();

  // Use Redux user data if available, otherwise fall back to localStorage user data
  const currentUser = user || users?.userData;
  const userName = currentUser?.firstName;

  const isTourCompleted = user?.isTourCompleted;

  const admin = JSON.parse(localStorage.getItem("user"));
  // ----------------------------------Personal-info-validation-------------------------------------

  const validatePersonalInfo = () => {
    if (language === LOCALES.EN_US) {
      dispatch(resetGetInvoiceData());
      navigate(`/dashboard/invoice-tool?lang=${LOCALES.EN_US}`);
    } else {
            dispatch(resetGetInvoiceData());
      navigate(`/instrumentbrada/faktura-verktyg?lang=${LOCALES.SV_SE}`);
    }
  };

  useEffect(() => {
    if (user) {
      dispatch(getAllTimeSheet());
    }
    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(() => {
    if (isTourCompleted) mobileScroll();
  }, []);

  // const updateTourStatus = useUpdateTourStatus();

  // const stepsArray = tourSteps(updateTourStatus, t);

  // useEffect(() => {
  //   if (isTourOpen) {
  //     document.body.classList.add("no-scroll");
  //   } else {
  //     document.body.classList.remove("no-scroll");
  //   }

  //   return () => {
  //     document.body.classList.remove("no-scroll");
  //   };
  // }, [isTourOpen]);

  return (
    <Layout
      className="p-4 layout mt-5 new_dashbrd_desgns activities actvs_desgns"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/activities"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/aktiviteter"
          />
        )}
      </Helmet>

      {/* {users?.userData?.isVerified === false && (
        <div style={{ margin: "10px 0px" }}>
          <UpdatePendingVerification />
        </div>
      )} */}

      <h4 className="accident_ins  mb-0">
        <span style={{ color: "#5D47B6" }}>
          {t("Hello")} <span>{userName ? userName : "Random Guy"},</span>{" "}
        </span>
        {t("actdo")}
      </h4>

      <div className="row m-0 my-4 dashboard-button-scroll-container ">
        <div
          className={`cursor-pointer ${
            viewportWidth < 768 ? "hide-mobile" : ""
          }`}
          id={window.innerWidth < 768 ? "step5" : "step1"}
          onClick={() => validatePersonalInfo()}
        >
          <AiOutlineSetting size={35} color="#9073c3" />
          <Button variant="" className="text-dark text-left  mb-0">
            {t("Create invoice")}
          </Button>
        </div>
        <div
          className={`cursor-pointer ${
            viewportWidth < 768 ? "hide-mobile" : ""
          }`}
          onClick={() =>
            // getAllTimeSheetData.length > 0
            //   ? handleEditTimeSheet()
            //   :
            language === LOCALES.EN_US
              ? navigate(`/dashboard/time-sheet?lang=${LOCALES.EN_US}`)
              : navigate(`/instrumentbrada/tidrapport?lang=${LOCALES.SV_SE}`)
          }
          id={window.innerWidth < 768 ? "step6" : "step2"}
        >
          <GrDocumentTime size={20} className="iconTimeSheet" />
          <Button
            variant=""
            disabled={isLoading}
            className="text-dark text-left  mb-0"
          >
            {t("Create timesheet")}
            {/* {isLoading
              ? t("Please wait...")
              : getAllTimeSheetData.length > 0
              ? t("Edit timesheet")
              : t("Create timesheet")} */}
          </Button>
        </div>
        <div
          className={`cursor-pointer ${
            viewportWidth < 768 ? "hide-mobile" : ""
          }`}
          onClick={() => {
            window.open(
              language === LOCALES.EN_US ? tender : newTenderSwedish,
              "_blank"
            );
          }}
        >
          <AiOutlineFileProtect size={35} color="#9073c3" />
          <Button
            variant=""
            className="text-dark text-left mb-0"
            onClick={() => {
              window.open(
                language === LOCALES.EN_US ? tender : newTenderSwedish,
                "_blank"
              );
            }}
          >
            {t("acttender")}
          </Button>
        </div>
        <div
          className={`cursor-pointer ${
            viewportWidth < 768 ? "hide-mobile" : ""
          }`}
          onClick={() =>
            window.open(
              language === LOCALES.EN_US ? contract : newContractSwidish,
              "_blank"
            )
          }
        >
          <AiOutlineFileText size={35} color="#9073c3" />
          <Button variant="" className="text-dark text-left mb-0">
            {t("write a contract")}
          </Button>
        </div>
      </div>

      <NewLaunched language={language} t={t} />

      {/* {!isTourCompleted && (
        <Tour
          steps={stepsArray}
          isOpen={isTourOpen}
          accentColor="#5D47B6"
          onRequestClose={() => {
            setIsTourOpen(false);
            updateTourStatus();
          }}
          disableInteraction
          showNavigationNumber={true}
          showNavigation={true}
          showButtons={false}
          styles={{
            helper: (base) => ({
              ...base,
              width: window.innerWidth < 768 ? "90%" : "40%",
              padding: window.innerWidth < 768 ? "20px" : "40px",
            }),
            content: (base) => ({
              ...base,
              fontSize: window.innerWidth < 768 ? "14px" : "16px",
            }),
            button: (base) => ({
              ...base,
              fontSize: window.innerWidth < 768 ? "12px" : "14px",
            }),
          }}
        />
      )} */}

      {/* <div className="col-md-12 right p-0">
        <h6>{t("We strive to support entrepreneurs to start their")}</h6>
        <FunctionPage />
      </div> */}

      {/* <div className="text-center mb-3">
        <Button
          className="mr-3 mt-4 bottom_create_btn"
          onClick={() =>
            navigate(
              language === "en"
                ? "/dashboard/calculator-anchor?lang=en"
                : "/instrumentbrada/kalkylator-ankare?lang=de"
            )
          }
        >
          {t("Calculator")}
        </Button>
      </div> */}
    </Layout>
  );
};

export default Activities;
